import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LanguageService } from './language.service';

@Injectable({
  providedIn: 'root'
})
export class LegacyUrlInterceptorService {

  constructor(
    private router: Router,
    private languageService: LanguageService
  ) {
    this.initializeUrlInterceptor();
  }

  private initializeUrlInterceptor(): void {
    // Listen to navigation events
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.handleNavigationEnd(event.url);
        }
      });
  }

  private handleNavigationEnd(url: string): void {
    // Split URL into path and query string
    const urlParts = url.split('?');
    const path = urlParts[0];
    const queryString = urlParts.length > 1 ? urlParts[1] : '';
    
    // Check if URL contains legacy language prefix
    const legacyMatch = path.match(/^\/(tr|en|de|ar|fr)\/(.*)/);
    
    if (legacyMatch) {
      const [, langCode, remainingPath] = legacyMatch;
      // Preserve query string if exists
      const newUrl = '/' + remainingPath + (queryString ? '?' + queryString : '');
      
      console.log(`Legacy URL intercepted: ${url} -> redirecting to: ${newUrl} with language: ${langCode} (query: ${queryString || 'none'})`);
      
      // Set language before redirecting
      this.languageService.setLanguage(langCode);
      
      // Redirect to new URL structure with query params preserved
      this.router.navigateByUrl(newUrl, { replaceUrl: true });
    }
  }

  /**
   * Manually handle legacy URL redirect
   */
  public redirectLegacyUrl(url: string): boolean {
    // Split URL into path and query string
    const urlParts = url.split('?');
    const path = urlParts[0];
    const queryString = urlParts.length > 1 ? urlParts[1] : '';
    
    const legacyMatch = path.match(/^\/(tr|en|de|ar|fr)\/(.*)/);
    
    if (legacyMatch) {
      const [, langCode, remainingPath] = legacyMatch;
      // Preserve query string if exists
      const newUrl = '/' + remainingPath + (queryString ? '?' + queryString : '');
      
      console.log(`Manually redirecting legacy URL: ${url} -> ${newUrl} with language: ${langCode} (query: ${queryString || 'none'})`);
      
      // Set language before redirecting
      this.languageService.setLanguage(langCode);
      
      this.router.navigateByUrl(newUrl, { replaceUrl: true });
      return true;
    }
    
    return false;
  }
}